import type { QueueColumn } from '@/components/designSystem/QueueViews/types'
import { CONTAINER_STAGE_LABELS } from '@/constants/ds-attendance-sla.constants'
import type { ContainerStage } from '@/constants/ds-attendance-sla.constants'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'

/** `'2026-09-28'` → `'28/09'` (data civil do plantão, sem fuso). */
export const formatReferenceDay = (date: string): string => {
  const [, month, day] = date.split('-')
  return day && month ? `${day}/${month}` : date
}

export const shiftNames = (container: Pick<DSAttendanceContainer, 'shifts'>): string =>
  (container.shifts ?? []).map((shift) => shift.name).join(', ') || 'Sem turno'

export const stageLabel = (stage: ContainerStage | null | undefined): string => {
  if (!stage) return '—'
  return stage === 'CLOSED' ? 'Encerrado' : CONTAINER_STAGE_LABELS[stage]
}

/** Colunas do mockup --tabela; células ricas vêm por slot em `DsAttendanceQueueViews`. */
export const DS_ATTENDANCE_TABLE_COLUMNS: QueueColumn<DSAttendanceContainer>[] = [
  { key: 'id', label: 'ID', widthClass: 'w-20' },
  {
    key: 'referenceDate',
    label: 'Plantão',
    value: (row) => formatReferenceDay(row.referenceDate),
    widthClass: 'w-20'
  },
  { key: 'schedule', label: 'Escala / Unidade' },
  { key: 'shifts', label: 'Turnos', value: shiftNames },
  { key: 'status', label: 'Status' },
  { key: 'stage', label: 'Etapa', value: (row) => stageLabel(row.stage) },
  { key: 'deadline', label: 'Prazo', sortable: true },
  { key: 'slaState', label: 'Estado' }
]
